"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "LinkContainer", {
  enumerable: true,
  get: function get() {
    return _LinkContainer["default"];
  }
});

var _LinkContainer = _interopRequireDefault(require("./LinkContainer"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }